export const mapDraftForCreate = ({
  fulfillmentCenter,
  purchaseOrderNumber,
  destinationFulfillmentCenter
}) => ({
  FulfillmentCenterId: fulfillmentCenter.id,
  FulfillmentCenterName: fulfillmentCenter.name,
  purchaseOrderNumber,
  FinalDestinationFulfillmentCenterId: destinationFulfillmentCenter && destinationFulfillmentCenter.id
})
